import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common'
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MetaDataService {

  prefixTitle: string = " | Pickright"

  constructor(
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) private document: Document
  ) { }

  setTitle(text: string) {
    let title: string = ''
    title = text.length > 160 ? `${text.slice(0, 158)}...` : text
    this.titleService.setTitle(title)
    this.setOGTitle(title)
  }

  setMetaDesc(text: string) {
    let desc: string = ''
    desc = text.length > 347 ? `${text.slice(0, 347)}...` : text
    this.metaService.updateTag({ name: 'description', content: desc })
    this.setOGDesc(desc)
  }

  setMetaKeywords(keywords: string) {
    this.metaService.updateTag({ name: 'keywords', content: keywords })
  }

  setOGTitle(title) {
    this.metaService.updateTag({ property: 'og:title', content: title })
  }

  setOGDesc(desc) {
    this.metaService.updateTag({ property: 'og:description', content: desc })
  }

  setRoute(route) {
    this.metaService.updateTag({ property: 'og:url', content: route })
    let tag = this.document.getElementById('canonical')
    if (tag) {
      tag.setAttribute('href', route)
    }
  }

  setSEOIndex(isEnable: boolean) {
    this.metaService.updateTag({ name: "robots", content: isEnable ? 'index,follow' : 'noindex,nofollow' })
    this.metaService.updateTag({ name: "googlebot", content: isEnable ? 'index' : 'noindex' })
  }
  addGooleTagmanager() {
    let scriptHead = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${environment.googleTagID}');`
    let scriptHeadEle = document.createElement('script')
    scriptHeadEle.text = scriptHead
    document.head.appendChild(scriptHeadEle)


    let scriptBody = document.createElement('noScrip')
    let iframe: any = document.createElement('iframe')
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${environment.googleTagID}`
    iframe.width = '0px'
    iframe.height = '0px'
    iframe.setAttribute('style', "display:none;visibility:hidden")
    scriptBody.appendChild(iframe)
    document.body.appendChild(scriptBody)
  }
}
